<div [ngStyle]="styles">
  <div class="modal-header ps-0 border-0 pb-6 pt-0">
    <h4
      class="modal-title text-primary text-truncate"
      data-automation-id="welcome-text"
    >
      Welcome
      <strong data-automation-id="welcome-user">{{
        (userMetaData$ | async)?.first_name
      }}</strong>
    </h4>

    <button
      *ngIf="isMobile"
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <ul
    class="list-unstyled mb-4 pb-9 border-bottom border-black"
    data-automation-id="account-items"
  >
    <li class="py-4" *ngFor="let option of filteredLoginOptions">
      <digital-platform-rsx-a
        [url]="option.route"
        (click)="onLinkClick()"
        klass="text-color-black text-decoration-none py-6"
        [attr.data-automation-id]="option.title"
      >
        <digital-platform-icon
          [icon]="option.icon"
          [width]="17"
          [height]="17"
          class="me-6"
        ></digital-platform-icon>
        {{ option.title }}
      </digital-platform-rsx-a>
    </li>
  </ul>

  <digital-platform-button
    class="d-flex justify-content-end mt-8"
    color="primary"
    size="lg"
    backgroundType="light"
    label="Log Out"
    data-automation-id="Logout-button"
    (onclick)="logout()"
  ></digital-platform-button>
</div>
